import { MarkShape } from '@mui/x-charts/models';

import { MarketId } from 'types/market-id.enum';

// Categorical palette slots. Farms take FIRST_FARM_SLOT onwards, in farm option order.
export const COMPANY_SLOT = 0;
export const MARKET_SLOT = 1;
export const FIRST_FARM_SLOT = 2;

// Farm shapes per pass through the palette. Circle and square stay with company and market.
export const FARM_SHAPES: MarkShape[] = ['diamond', 'triangle', 'star', 'wye', 'cross'];

// Markets without a code here fall back to the company's market name.
export const MARKET_SHORT_CODES: Partial<Record<MarketId, string>> = {
  [MarketId.Ecuador]: 'EC',
  [MarketId.Mexico]: 'MX',
};
